// extracted by mini-css-extract-plugin
export default {"tooltip_block":"styles_tooltip_block__z-048"};